import { widgetNodeSchemas } from '@/lib/report-document'

import type { WidgetNodeName } from '../nodes/data-source'

/*
 * `document_runs.data` anahtarları (sorgu anahtarı -> satırlar). Adlandırılmış sorgu adları nokta
 * içeremez (`query-name.ts`), bu yüzden `.previous` / `.totals` sonekleri ve `widget.` öneki
 * adlarla çakışmaz. Donmuş kaynak (okuma) ve kopya üretimi (D7.3, yazma) aynı anahtarları kullanır.
 */

/** Adlandırılmış sorgunun satırları: anahtar sorgu adıdır. */
export const namedDataKey = (name: string) => name

/** `compare: "previous"` sorgusunun / KPI'nın önceki dönem satırları. */
export const previousDataKey = (key: string) => `${key}.previous`

/** Tablo/liste toplam satırları (döviz başına). */
export const totalsDataKey = (key: string) => `${key}.totals`

/** Anahtar sırası öznitelik sırasından bağımsız olsun diye düğüm öznitelikleri sıralı serileştirilir. */
function canonical(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonical).join(',')}]`
  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, item]) => item !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
    return `{${entries.map(([key, item]) => `${JSON.stringify(key)}:${canonical(item)}`).join(',')}}`
  }
  return JSON.stringify(value) ?? 'null'
}

/** FNV-1a 32 bit; kriptografik değil, yalnız kararlı kısa anahtar. */
function fnv1a(text: string): string {
  let hash = 0x811c9dc5
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }
  return (hash >>> 0).toString(16).padStart(8, '0')
}

/**
 * Widget düğümünün satırları. Düğümde kimlik yoktur ve metin düzenlemesi blokları silip
 * taşıyabilir; bu yüzden anahtar sıradan değil düğümün türü + özniteliklerinden türetilir
 * (aynı öznitelikli iki widget aynı sonucu paylaşır). Öznitelikler şema varsayılanlarıyla
 * normalleştirilir: üretim ayrıştırılmış tanımdan, çizim ham TipTap düğümünden okur.
 */
export const widgetDataKey = (type: WidgetNodeName, attrs: Record<string, unknown>) => {
  const parsed = widgetNodeSchemas[type].shape.attrs.safeParse(attrs)
  return `widget.${type}.${fnv1a(canonical(parsed.success ? parsed.data : attrs))}`
}
